<template>
  <div class="admin-cell-related" :style="containerStyles">
    <div class="overflow-hidden truncate placeholder-container">
      <AdminInputRelated v-bind="{ ...$attrs, ...$props }" @update="update" />
    </div>
  </div>
</template>

<script>
import { Model } from '@vuex-orm/core'
import AdminInputRelated from '@/components/AdminInputRelated'
export default {
  name: 'AdminCellRelated',
  components: {
    AdminInputRelated,
  },
  props: {
    width: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
    id: {
      type: [String, Number],
      require: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    },
  },
  methods: {
    update(fields) {
      if ('function' === typeof this.Model.updateModel) {
        this.Model.updateModel(this.id, fields)
      }
    }, // update
  },
}
</script>

<style scoped>
.placeholder-container {
  cursor: pointer;
}
.truncate {
  height: auto;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
